import { render, staticRenderFns } from "./messageTemplete.vue?vue&type=template&id=0213e924&scoped=true"
import script from "./messageTemplete.vue?vue&type=script&lang=js"
export * from "./messageTemplete.vue?vue&type=script&lang=js"
import style0 from "./messageTemplete.vue?vue&type=style&index=0&id=0213e924&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0213e924",
  null
  
)

export default component.exports